import PropTypes from 'prop-types';
import { HelpCircle } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '#/modules/commonComponents/tooltip';

const ColumnTipHeader = ({ label, tip }) => {
  return (
    <span className="inline-flex items-center justify-center gap-0.5">
      <span>{label}</span>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="
              text-gray-400 inline-flex cursor-help items-center border-0 bg-transparent p-0
              hover:text-primary-600
            "
            aria-label={`${label}說明`}
            onClick={(event) => event.stopPropagation()}
            onMouseDown={(event) => event.stopPropagation()}
          >
            <HelpCircle size={14} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          {tip}
        </TooltipContent>
      </Tooltip>
    </span>
  );
};

ColumnTipHeader.propTypes = {
  label: PropTypes.string.isRequired,
  tip: PropTypes.string.isRequired,
};

export default ColumnTipHeader;
